<template>
  
  <template v-if="contentStore.select_component != null">

        <v-menu 
          v-model="dialog_com"
          location="start"
          :close-on-content-click="false"
          @update:modelValue="menu_handler"
          >
          <template v-slot:activator="{ props }">
            <div v-bind="props" style="cursor:pointer">
            <v-icon icon="mdi-format-color-text" color="black" />
            <div style="width:25px;height:6px;border:1px gray solid"
                :style="'background:'+contentStore.select_component.model[property]"
                  />
            </div>
          </template>

          <v-card class="ma-0 pa-1">
            <v-row dense align="center" class="pa-0 ma-0">
              <v-col cols="9" class="ml-5 mt-2">
                <label style="color:black">{{title}}</label>
              </v-col>
              <v-col cols="2" class="mt-2">
                <v-btn size="small" variant="icon" class="dialog_close_btn mr-1" @click="close_com"><v-icon>mdi-close</v-icon></v-btn>
              </v-col>
            </v-row>

            <v-row dense justify="center" class="pa-0 ma-0">
              <v-col cols="11">
                <div style="background:gray;height:1px;" />
              </v-col>
            </v-row>

            <v-card-text>
              <v-container>
                <v-row justify="center">

                  <Vue3ColorPicker style="width: 270px;" class="elevation-0"
                    :model-value="getColorValue()" 
                    mode="solid" 
                    :show-alpha="showAlpha"
                    show-eye-drop="true" show-input-menu="true"
                    @update:modelValue="handleColorChange"
                    />      

                </v-row>
              </v-container>
            </v-card-text> 

            <v-row dense justify="center" class="pa-0 ma-0">
              <v-col cols="11">
                <div style="background:gray;height:1px;" />
              </v-col>
            </v-row>

            <v-card-actions>
              <v-row justify="center">
              <v-btn variant="text" size="small" @click="close_com">취소</v-btn>
              <v-btn variant="text" size="small" class="ml-5" @click="save_com">선택</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>

        </v-menu>


  </template>

</template>

<script>
import { Vue3ColorPicker } from '@cyhnkckali/vue3-color-picker';
import '@cyhnkckali/vue3-color-picker/dist/style.css'
import { useContentStore } from "@/stores/content";

    export default {
        components:{
          Vue3ColorPicker
        },

        props:{
          
          title:{
            type:String,
            default(){
              return "";
            }
          },
          
          property:{
            type:String,
            default(){
              return "";
            }
          },
          
          showAlpha:{
            type:Boolean,
            default(){
              return true;
            }
          },
          
        },

        setup(){
          //let colorstring = ref(props.color);
          const contentStore = useContentStore();
          return {contentStore};
        },

        mounted(){
          
        },

        data: ()=> ({
            dialog_com : false,
            disabled:false,
            text_backup:"",
        }),

        methods: {

            //다이얼로그 닫기
            close_com () {
              this.contentStore.select_component.model[this.property] = this.text_backup;
              this.updateRender();
              this.dialog_com = false
            },

            //추가 저장
            save_com () {
              //콜백 호출 후 닫아야함.
              //this.$emit('callback');
              this.updateRender();
              this.dialog_com = false
            },      

            menu_handler(){
              //최초 또는 메뉴 외곽 클릭시 
              //텍스트값 백업
              this.text_backup = this.contentStore.select_component.model[this.property];
            },

            //편집창 컴포넌트 렌더링
            updateRender(){
                if(this.contentStore.select_component != null){
                    this.contentStore.saveSnapshot();
                    this.contentStore.select_component.updateRender();
                }
            },

            //색상 값 가져오기 (안전한 형식 보장)
            getColorValue(){
                if(!this.contentStore.select_component) {
                    return '#3B82F6'; // 기본 색상
                }
                
                const colorValue = this.contentStore.select_component.model[this.property];
                
                // 유효한 문자열인지 확인
                if(typeof colorValue === 'string' && colorValue.trim()) {
                    return colorValue;
                }
                
                return '#3B82F6'; // 기본 색상
            },

            //색상 변경 핸들러 (실시간 반영용)
            handleColorChange(newColor){
                console.log('DialogColor - 색상 변경:', newColor, typeof newColor);
                
                // 유효성 검사
                if(!newColor || this.contentStore.select_component == null) {
                    return;
                }
                
                try {
                    // 색상 값 검증 및 변환
                    let colorValue = newColor;
                    
                    // 객체 형태의 색상 값 처리 (Vue3ColorPicker가 객체를 반환할 수 있음)
                    if (typeof newColor === 'object' && newColor !== null) {
                        if (newColor.hex) {
                            colorValue = newColor.hex;
                        } else if (newColor.rgba) {
                            const { r, g, b, a } = newColor.rgba;
                            colorValue = `rgba(${r}, ${g}, ${b}, ${a})`;
                        } else if (newColor.rgb) {
                            const { r, g, b } = newColor.rgb;
                            colorValue = `rgb(${r}, ${g}, ${b})`;
                        } else {
                            console.warn('Unknown color object format:', newColor);
                            return;
                        }
                    }
                    
                    // 문자열 검증
                    if (typeof colorValue !== 'string') {
                        console.warn('Color value is not a string:', colorValue);
                        return;
                    }
                    
                    this.contentStore.select_component.model[this.property] = colorValue;
                    
                    // 즉시 렌더링 업데이트
                    this.$nextTick(() => {
                        this.updateRender();
                    });
                } catch (error) {
                    console.error('Error handling color change:', error);
                }
            },

        }

    }
</script>

<style scoped>


</style>